/**
 * Notifiche ufficio tecnico — demo in-app.
 * Produzione: backend + Web Push (VAPID) + email transazionale.
 */

import { toast } from "sonner";
import { getUfficioTecnicoContact } from "../data/tutelaUfficioTecnico";

const NOTIF_KEY = "tutela_notifications_queue";

function readQueue() {
  try {
    return JSON.parse(localStorage.getItem(NOTIF_KEY) || "[]");
  } catch {
    return [];
  }
}

function writeQueue(list) {
  localStorage.setItem(NOTIF_KEY, JSON.stringify(list.slice(0, 50)));
}

export function queueTutelaNotification({ comuneSlug, comuneName, segnalazioneId, preview }) {
  const contact = getUfficioTecnicoContact(comuneSlug, comuneName);
  const entry = {
    id: `tn-${Date.now().toString(36)}`,
    at: new Date().toISOString(),
    segnalazioneId,
    comuneSlug,
    comuneName,
    destinatario: contact.email,
    referente: contact.referente,
    preview: preview || "Segnalazione degrado patrimoniale",
    channel: "demo_in_app",
    read: false,
  };
  const q = readQueue();
  q.unshift(entry);
  writeQueue(q);
  return entry;
}

export function listTutelaNotifications() {
  return readQueue();
}

/** Simula invio push: toast + banner event (produzione richiede SW + VAPID). */
export function notifyUfficioTecnico({ comuneSlug, comuneName, segnalazioneId, preview }) {
  const contact = getUfficioTecnicoContact(comuneSlug, comuneName);
  const entry = queueTutelaNotification({ comuneSlug, comuneName, segnalazioneId, preview });

  const msg = contact.demo
    ? `[Demo] Segnalazione in coda per ${contact.referente} (${contact.email})`
    : `Segnalazione inviata a ${contact.referente}`;

  toast.success(msg, {
    description: preview?.slice(0, 120) || "Protocollo Tutela · Segnala Degrado",
    duration: 8000,
  });

  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("6amico-tutela-notification", { detail: { entry, contact } })
    );
  }

  return { entry, contact, webPushReady: false };
}

/**
 * Produzione: registrare subscription con VAPID public key dal backend.
 * Non attivato — nessun service worker nel progetto CRA attuale.
 */
export function canUseWebPush() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    false
  );
}
